import { SVGProps, Ref, forwardRef } from 'react';

export const MapOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.5-.002c2.312 1.319 4.65 2.615 6.957 3.912l2.847-1.764.027-.015c.657-.376 1.322-.722 1.939-.906.598-.178 1.628-.339 2.53.376.782.617.99 1.547 1.078 2.099.1.637.122 1.413.122 2.256v8.059c0 1.655-.073 3.115-.713 4.375-.666 1.31-1.803 2.14-3.137 2.957l-.007.005-.008.004c-1.526.915-3.09 1.765-4.635 2.646-2.31-1.317-4.636-2.608-6.955-3.91L5.97 21.695l-.02.012c-.711.417-1.402.791-2.024 1.005-.563.194-1.6.444-2.56-.193-.898-.594-1.136-1.588-1.232-2.152C.023 19.714 0 18.912 0 18.044V9.985C0 8.33.073 6.87.713 5.611 1.58 3.904 3.325 2.934 4.93 2.025Q6.717 1.014 8.5-.002m-5.187 5.22C2.027 6.31 1.8 7.406 1.8 9.984v8.06c0 3.46.41 3.767 3.238 2.11L7.6 18.56V2.582c-1.5.851-2.956 1.504-4.287 2.635M9.4 18.507V2.58c1.705.963 3.493 1.953 5.2 2.912v15.926c-1.735-.98-3.498-1.955-5.2-2.912m7 2.913c.942-.529 1.854-1.036 2.81-1.609 2.605-1.594 2.99-2.44 2.99-5.797v-8.06c0-3.35-.384-3.744-2.975-2.262L16.4 5.443z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
MapOutlinedSize24Glyph.displayName = 'MapOutlinedSize24Glyph';
